import { Suspense } from "react";
import { MyInvitationsSkeleton } from "./components/my-invitations/my-invitations-skeleton";
import { MyInvitationsPage } from "./my-invitations-page";

type InvitationsListProps = {
  projectId?: string;
  focusedInvitationId?: string;
};

export function InvitationsList({
  projectId,
  focusedInvitationId,
}: InvitationsListProps) {
  return (
    <Suspense fallback={<MyInvitationsSkeleton />}>
      <MyInvitationsPage
        focusedInvitationId={focusedInvitationId}
        projectId={projectId}
      />
    </Suspense>
  );
}
